import * as React from "react";
export class DateTime extends React.Component {
    render() {
        return (React.createElement("div", { className: "rj-racing-future-events__date-time" },
            React.createElement("span", null, this.props.date),
            React.createElement("span", null, "\u2002-\u2002"),
            React.createElement("span", null, this.props.time)));
    }
}
//# sourceMappingURL=DateTime.js.map